import React, { useState, useEffect } from 'react'
import { Accordion, Button, Spinner } from 'react-bootstrap';
import TopHeading from '../Heading/TopHeading';
import { AddFAQ } from './AddFAQ';
import { EditFAQ } from './EditFAQ';
import { Loader, NoContent } from '../UI';
import axios from '../../axios';
import { toast } from 'react-toastify';

export default function FAQsContent() {
  const authToken = localStorage.getItem('access_token');
  const isAdmin = localStorage.getItem('isAdmin');
  const [faqs, setFaqs] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [delLoading, setDelLoading] = useState(false);
  const [addShow, setAddShow] = useState(false);

  const handleAddClose = () => setAddShow(!addShow);

  const fetchFAQs = () => {
    axios.get('/faqs', {
      headers: {
        'Authorization': `Bearer ${authToken}`
      }
    })
    .then((response) => {
      if (response.data) {
        setFaqs(response.data);
        setIsLoading(false);
      }
    })
    .catch((error) => {
      toast.error('Couldn\'t Load FAQs');
      setIsLoading(false);
    })
  };

  const addNewFAQ = (values, setSubmitting) => {
    axios.post('/faqs', values, {
        headers: {
          'Authorization': `Bearer ${authToken}`
        }
    })
    .then((response) => {
        if (response.status === 200) {
            toast.success(response.data.message);
            handleAddClose();
        } else {
            toast.warn('No response from server');
        }
        setSubmitting(false);
    })
    .catch((error) => {
        toast.error('Something went wrong');
        setSubmitting(false);
    })
  };

  const deleteFAQ = (id) => {
    setDelLoading(true);
    axios.delete(`/faqs/${id}`, {
        headers: {
          'Authorization': `Bearer ${authToken}`
        }
    })
    .then((response) => {
        if (response.status === 200) {
            toast.success(response.data.message);
            fetchFAQs();
        } else {
            toast.warn('No response from server');
        }
        setDelLoading(false);
    })
    .catch((error) => {
        toast.error('Something went wrong');
    })
  };

  useEffect(() => {
    fetchFAQs();
  }, []);

  return (
    <section className='faqs-content'>
      <div className='container'>
        <div className='row g-0'>
          <div className='col-md-12'>
            <TopHeading title='FAQs' />
            {
              isAdmin != 0 &&
              <AddFAQ 
                show={addShow}
                handleClose={handleAddClose}
                addNewFAQ={addNewFAQ} 
              />
            }
            <div className='faqs pe-2 custom-scrollbar'>
              {
                isLoading ? (
                  <Loader />
                ) : (
                  faqs.length ? (
                    faqs.map((faq) => {
                      return (
                        <Accordion key={faq.faqId} defaultActiveKey={faq.faqId}>
                          <Accordion.Item eventKey={faq.faqId}>
                            <Accordion.Header>
                              {faq.question}
                            </Accordion.Header>
                            <Accordion.Body>
                              {faq.answer}
                            </Accordion.Body>
                          </Accordion.Item>
                          <Accordion.Item>
                            <div className='d-flex justify-content-end'>
                              {
                                isAdmin != 0 &&
                                <>
                                  <EditFAQ 
                                    data={faq} 
                                    authToken={authToken} 
                                    fetchFAQs={fetchFAQs} 
                                    delLoading={delLoading}
                                  />
                                  <Button variant="danger" size={'sm'} onClick={() => deleteFAQ(faq.faqId)} disabled={delLoading}>
                                    Delete 
                                    {
                                      delLoading &&
                                      <Spinner
                                        as="span"
                                        animation="border"
                                        size="sm"
                                        role="status"
                                        aria-hidden="true"
                                        className='ms-2'
                                      />
                                    }
                                  </Button>
                                </>
                              }
                            </div>
                          </Accordion.Item>
                        </Accordion>
                      )
                    })
                  ) : (
                    <NoContent />
                  )
                )
              }
              
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
